import React from 'react';
import { Link } from 'react-router-dom';
import '../pages/TrustPages.css';

/**
 * Shared trust copy: online ordering + support available around the clock.
 */
export default function TrustSupportBanner({ variant = 'banner', className = '' }) {
  if (variant === 'inline') {
    return (
      <p className={`trust-support-inline ${className}`.trim()}>
        <strong>24/7 open</strong> — place orders anytime. Customer support is available day and night for order help,
        tracking, and returns.
      </p>
    );
  }

  return (
    <aside
      className={`trust-support-banner ${className}`.trim()}
      aria-label="Orders and support availability"
    >
      <span className="trust-support-banner__icon" aria-hidden>
        🕐
      </span>
      <div className="trust-support-banner__body">
        <p className="trust-support-banner__title">Orders &amp; support — open 24/7</p>
        <p className="trust-support-banner__text">
          Shop and checkout anytime on our website. Need help with an order, payment, or delivery? Our team is here{' '}
          <strong>24 hours a day, 7 days a week</strong> via phone, email, and WhatsApp.
        </p>
        <Link to="/contact" className="trust-support-banner__link">
          Contact support →
        </Link>
      </div>
    </aside>
  );
}
